import { React, PropTypes } from '@gasbuddy/react';
import { Button, Text } from '@gasbuddy/react-components';
import Markdown from 'react-markdown';
import style from './style.css';
import CategoryList from './CategoryList';
import CategoryDetail from './CategoryDetail';

const offerStringMapping = {
  details: 'Details',
  instructions: 'How It Works',
  fine_print: 'Fine Print',
};

const backgroundImageUrl = 'https://images.gasbuddy.io/autox240';
const logoUrl = 'https://images.gasbuddy.io/autox150';

export class OfferDetail extends React.Component {
  static propTypes = {
    offer: PropTypes.shape({
      link: PropTypes.shape({
        deeplink_url: PropTypes.string.isRequired,
      }).isRequired,
      partner: PropTypes.shape({
        image_url: PropTypes.string,
        name: PropTypes.string,
      }).isRequired,
      image_url: PropTypes.string,
      offer_id: PropTypes.string.isRequired,
    }).isRequired,
  };

  state = {}

  onShopNowClick = () => {
  }

  onDetail = (category) => {
    if (category.detail) {
      this.setState({ category });
    }
  }

  render() {
    const { category } = this.state;
    const { offer } = this.props;
    const {
      link,
      partner,
      reward_text: rewardText,
      image_url: backgroundImage,
    } = offer;

    const offerItemList = Object.keys(offer)
      .filter(key => Object.keys(offerStringMapping).includes(key))
      .map(val => ({ header: offerStringMapping[val], copy: offer[val] }), []);

    if (offer.categories?.length > 1) {
      offerItemList.splice(1, 0, () => <CategoryList className={style.categoryList} onDetail={this.onDetail} categories={offer.categories} />);
    }

    return (
      <div>
        {category && <CategoryDetail category={category} onClose={() => this.setState({ category: null })} />}
        <div style={{ background: `url('${backgroundImageUrl}/${backgroundImage}') center no-repeat`, backgroundSize: 'cover' }} className={style.imageContainer} />
        <div style={{ background: `url('${logoUrl}/${partner.image_url}') center no-repeat`, backgroundSize: 60, backgroundColor: 'white' }} className={style.partnerImageContainer} />
        <section className={style.detailsSection}>
          <header style={{ textAlign: 'center' }}>
            <div className={style.partnerName}>{partner.name}</div>
            <Text color="teal" className={style.rewardText}>{rewardText}</Text>
            <br />
            <span className={style.gasbackText}>GasBack</span>
            <br />
            <br />
            {
              offerItemList.map((item, index) => {
                const isLast = index === (offerItemList.length - 1);
                if (typeof item === 'function') {
                  return item();
                }
                return (
                  <React.Fragment key={index.toString()}>
                    <div className={style.itemContainer}>
                      <header className={style.itemHeader}>{item.header}</header>
                      <div className={`
                      ${style.itemCopy}
                      ${isLast ? style.lastItemMargin : undefined}`}
                      >
                        <Markdown source={item.copy} />
                      </div>
                    </div>
                    {
                      !isLast
                      && <div className={style.divider} />
                    }
                  </React.Fragment>
                );
              })
            }
          </header>
          <br />
          {

          }
        </section>
        <div className={style.shopNowContainer}>
          <Button
            className={style.shopNow}
            color="red"
            as="a"
            rounded
            fluid
            onClick={this.onShopNowClick}
            href={link.deeplink_url}
          >
            SHOP NOW
          </Button>
        </div>
      </div>
    );
  }
}
